import styled from "styled-components";

export const FooterWrapper = styled.footer`
  width: 100%;
  height: 60px;
  text-align: center;
  color: #616161;
  margin-top: 32px;
`;

export const FooterTitle = styled.h2`
  font-size: 1rem;
`;

export const FooterImg = styled.img`
  width: 1rem;
`;
